const storePlans = {
    namespaced: true,
    state: {
        ready: false,
        employerId: null,
        plans: []
    },
    getters: {
        planById: state => {
            return planId => getPlanById(state.plans, planId);
        },
        isPaysFirst: state => { //returns true if HRA and FSA are current and overlap at all
            for (var i = 0; i < state.plans.length; i++) {
                if (state.plans[i].planType === "HRA" && !["EPR","PRM","QDP","LSA"].includes(state.plans[i].hraOptions.hraType) && moment(state.plans[i].runOutDate).isSameOrAfter(moment())) {
                    for (var j = 0; j < state.plans.length; j++) {
                        if (state.plans[j].planType === "FSA" && state.plans[i].startDate <= state.plans[j].endDate && state.plans[i].endDate >= state.plans[j].startDate) {
                            return true;
                        }
                    }
                }
            }
            return false;
        },
        hasHsa: state => {
            return state.plans.some(p => p.planType == "HSA" && moment(p.endDate).isAfter(moment()) && !p.isTerminated);
        },
        hasFsa:state => {
            return state.plans.some(p => p.planType == "FSA" && moment(p.endDate).isAfter(moment()) && !p.isTerminated);
        },
        hasPOP:state => {
            return state.plans.some(p => p.planType == "POP" && moment(p.endDate).isAfter(moment()) && !p.isTerminated);
        },
        hasHra: state => {
            return state.plans.some(p => p.planType == "HRA" && moment(p.endDate).isAfter(moment()) && !p.isTerminated);
        },
        hasTelescope: state => {
            return state.plans.some(p => p.planType == "TEL" && !p.telescopePlus && moment(p.endDate).isAfter(moment()) && !p.isTerminated);
        },
        hasTelescopePlus: state => {
            return state.plans.some(p => p.planType == "TEL" && p.telescopePlus && moment(p.endDate).isAfter(moment()) && !p.isTerminated);
        },
        hasIntellect: state => {
            return state.plans.some(p => p.planType == "INT" && moment(p.endDate).isAfter(moment()) && !p.isTerminated);
        },
        hasCurrentOrPastHsa: state => {
            return state.plans.some(p => p.planType == "HSA");
        },
    },
    apiGetters: {
        planFlavors: "/config/plan-flavor"
    },
    actions: {
        async load({state, commit}, data) {
            let employerId = data.employerId;
            if(!employerId || (!data.refreshSameEmployer && state.employerId == employerId)) return;
            //if (state.allPlans && state.allPlans.length > 0 && state.allPlans[0].employerId == employerId) return;
            commit("updatePlansReady", false);

            let plans = await romeApi.get(`employer/${employerId}/plan`);
            plans = _.orderBy(plans, ['startDate', 'description'], ['desc', 'asc']);
            commit("updatePlans", { employerId, plans });
            commit("updatePlansReady", true);
        },
        async updateSinglePlan({state, commit}, plan){
            let planFromList = getPlanById(state.plans, plan.planId);
            if(!planFromList)
                throw `Plan ${plan.planId} not found for current employer.`;

            commit("updateSinglePlan", plan);
        }
    },
    mutations: {
        updatePlans(state, { employerId, plans }){
            state.employerId = employerId;
            state.plans = plans;
        },
        updatePlansReady(state, value){
            state.ready = value;
        },
        updateSinglePlan(state, value) {
            let planToUpdate = getPlanById(state.plans, value.planId);
            _.assign(planToUpdate, value);
        }
    }
};

function getPlanById(plans, planId){
    return plans.find(plan => plan.planId == planId);
}

export default storePlans;




// WEBPACK FOOTER //
// ./src/plans/x-plans.js